// src/config/relicVault/economy.js
//
// Store rules from the designer's handoff (relic-vault-react
// src/lib/vaultApi.ts). Relic and companion prices live on the catalog
// entries themselves.

/** Relic slots offered in the store at once. */
export const STORE_SLOT_COUNT = 5;

/**
 * Cost of each daily store refresh, in order: the first refresh of the day
 * costs 25 QuikCoins, the second 50. Add entries to allow more per day.
 */
export const REFRESH_COSTS = [25, 50];

/** Selling a relic back refunds this fraction of its price, rounded down. */
export const SELL_REFUND_RATIO = 0.5;

export function sellRefundFor(relic) {
  return Math.floor((relic?.price || 0) * SELL_REFUND_RATIO);
}

/** Today's date as "Y-M-D", used to gate the daily refresh allowance. */
export function todayStr() {
  const d = new Date();
  return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
}
